import React from "react";
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import Build from '@mui/icons-material/Build';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { useTranslation } from "../../hooks/useTranslation";

const AboutFeatures = () => {
  const { t } = useTranslation('about');
  const featuresData = t('features.items', { returnObjects: true });

  const icons = [
    <WbSunnyIcon className="feature-icon-svg" />,
    <SupportAgentIcon className="feature-icon-svg" />,
    <Build className="feature-icon-svg" />
  ];

  const features = featuresData.map((feature, index) => ({
    icon: icons[index],
    title: feature.title,
    description: feature.description
  }));

  return (
    <section className="about-features">
      <div className="about-features-container">
        <h2 className="about-features-title">{t('features.title')}</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-item">
              <div className="feature-icon">
                {feature.icon}
              </div>
              <div className="feature-content">
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
              <div className="feature-read-more">
                <span>{t('features.readMore')}</span>
                <ArrowForward className="read-more-arrow" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutFeatures;
